var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      title: _vm.$t("label_essweb_customForm_form_dialog_newItem"),
      dialog: _vm.show,
      width: "600",
      scrollable: "",
    },
    on: { close: _vm.closeDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  [
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("v-switch", {
                          staticClass: "ml-4",
                          attrs: {
                            color: "primary",
                            label: _vm.customFormItemData.is_required
                              ? _vm.$t(
                                  "label_essweb_customForm_form_dialog_isMandatoryLabel"
                                )
                              : _vm.$t(
                                  "label_essweb_customForm_form_dialog_isNotMandatoryLabel"
                                ),
                          },
                          model: {
                            value: _vm.customFormItemData.is_required,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData,
                                "is_required",
                                $$v
                              )
                            },
                            expression: "customFormItemData.is_required",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData: _vm.customFormItemData.custom_field_name,
                            maxlength: "100",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_customForm_form_dialog_labelLabel"
                            ),
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.customFormItemData.custom_field_name =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "v-sheet",
                          { staticClass: "mrc_text_require text--secondary" },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_customForm_form_dialog_typeLabel"
                                )
                              )
                            ),
                          ]
                        ),
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.Types,
                            "item-text": "view_fields",
                            "item-value": "value_field",
                            "single-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            "menu-props": {
                              offsetY: true,
                              transition: "slide-y-transition",
                              rounded: true,
                              contentClass: "elevation-4",
                            },
                            filled: "",
                            label: _vm.$t(
                              "label_essweb_customForm_form_dialog_typeLabel"
                            ),
                            dense: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "no-data",
                              fn: function () {
                                return [_c("noContent")]
                              },
                              proxy: true,
                            },
                          ]),
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData,
                                "custom_field_data_type",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_type",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("inputTextFiledMultiLang", {
                          attrs: {
                            bindData:
                              _vm.customFormItemData.custom_field_placeholder,
                            maxlength: "100",
                            TrigerInit: _vm.show,
                            label: _vm.$t(
                              "label_essweb_customForm_form_dialog_placeHolderLabel"
                            ),
                          },
                          on: {
                            change: function (valueArr) {
                              _vm.customFormItemData.custom_field_placeholder =
                                valueArr
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("numberInputTextFiled", {
                          attrs: {
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Length_Rules"],
                              [null, 15]
                            ),
                            label: _vm.$t(
                              "label_essweb_customForm_form_dialog_sequenceLabel"
                            ),
                            isNotRequire: "",
                          },
                          model: {
                            value: _vm.customFormItemData.sequence,
                            callback: function ($$v) {
                              _vm.$set(_vm.customFormItemData, "sequence", $$v)
                            },
                            expression: "customFormItemData.sequence",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("span", { staticClass: "text-h6 text--secondary" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "label_essweb_customForm_form_dialog_layoutLabel"
                                )
                              )
                          ),
                        ]),
                        _c(
                          "v-tooltip",
                          {
                            attrs: { top: "", color: "transparent" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "span",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass:
                                              "material-icons-round md-14 primary--text",
                                          },
                                          "span",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_vm._v(" question_mark")]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _c(
                              "v-sheet",
                              {
                                staticClass:
                                  "white elevation-3 pa-3 ma-n3 rounded-lg",
                              },
                              [
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "label_essweb_customForm_form_dialog_colsLabel"
                                        )
                                      ) + ":12~24"
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round md-18",
                                      },
                                      [_vm._v("smartphone")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        "< " +
                                          _vm.$vuetify.breakpoint.thresholds
                                            .xs +
                                          "px"
                                      ) + " "
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round md-18",
                                      },
                                      [_vm._v("stay_current_landscape")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$vuetify.breakpoint.thresholds.xs +
                                          "px > < " +
                                          _vm.$vuetify.breakpoint.thresholds
                                            .sm +
                                          "px"
                                      ) + " "
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round md-18",
                                      },
                                      [_vm._v("computer")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$vuetify.breakpoint.thresholds.sm +
                                          "px > < " +
                                          _vm.$vuetify.breakpoint.thresholds
                                            .md +
                                          "px"
                                      )
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round md-18",
                                      },
                                      [_vm._v("desktop_mac")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        _vm.$vuetify.breakpoint.thresholds.md +
                                          "px > < " +
                                          _vm.$vuetify.breakpoint.thresholds
                                            .lg +
                                          "px"
                                      )
                                    ),
                                  ]
                                ),
                                _c("br"),
                                _c(
                                  "v-sheet",
                                  {
                                    staticClass:
                                      "d-flex text--secondary text-caption",
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "material-icons-round md-18",
                                      },
                                      [_vm._v("desktop_windows")]
                                    ),
                                    _vm._v(
                                      _vm._s(
                                        "> " +
                                          _vm.$vuetify.breakpoint.thresholds
                                            .lg +
                                          "px"
                                      ) + " "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(["_Number_negative"], [null]),
                            label: _vm.$t(
                              "label_essweb_customForm_form_dialog_colsLabel"
                            ),
                            isNotRequire: "",
                            max: 24,
                            min: 12,
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .cols,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "cols",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.cols",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons-round md-18" },
                          [_vm._v("smartphone")]
                        ),
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Number_Max"],
                              [
                                null,
                                {
                                  number:
                                    _vm.customFormItemData
                                      .custom_field_data_layout.cols,
                                },
                              ]
                            ),
                            isNotRequire: "",
                            max: _vm.customFormItemData.custom_field_data_layout
                              .cols,
                            min: 0,
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .xs,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "xs",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.xs",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons-round md-18" },
                          [_vm._v("stay_current_landscape")]
                        ),
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Number_Max"],
                              [
                                null,
                                {
                                  number:
                                    _vm.customFormItemData
                                      .custom_field_data_layout.cols,
                                },
                              ]
                            ),
                            max: _vm.customFormItemData.custom_field_data_layout
                              .cols,
                            min: 0,
                            isNotRequire: "",
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .sm,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "sm",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.sm",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons-round md-18" },
                          [_vm._v("computer")]
                        ),
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Number_Max"],
                              [
                                null,
                                {
                                  number:
                                    _vm.customFormItemData
                                      .custom_field_data_layout.cols,
                                },
                              ]
                            ),
                            isNotRequire: "",
                            max: _vm.customFormItemData.custom_field_data_layout
                              .cols,
                            min: 0,
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .md,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "md",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.md",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons-round md-18" },
                          [_vm._v("desktop_mac")]
                        ),
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Number_Max"],
                              [
                                null,
                                {
                                  number:
                                    _vm.customFormItemData
                                      .custom_field_data_layout.cols,
                                },
                              ]
                            ),
                            isNotRequire: "",
                            max: _vm.customFormItemData.custom_field_data_layout
                              .cols,
                            min: 0,
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .lg,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "lg",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.lg",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      {
                        staticClass: "py-0 my-0",
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "6",
                          lg: "6",
                          cols: "12",
                        },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "material-icons-round md-18" },
                          [_vm._v("desktop_windows")]
                        ),
                        _c("numberInputTextFiled", {
                          attrs: {
                            readonly: "",
                            rules: _vm.$GetRules(
                              ["_Number_negative", "_Number_Max"],
                              [
                                null,
                                {
                                  number:
                                    _vm.customFormItemData
                                      .custom_field_data_layout.cols,
                                },
                              ]
                            ),
                            isNotRequire: "",
                            max: _vm.customFormItemData.custom_field_data_layout
                              .cols,
                            min: 0,
                          },
                          model: {
                            value:
                              _vm.customFormItemData.custom_field_data_layout
                                .xl,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.customFormItemData.custom_field_data_layout,
                                "xl",
                                $$v
                              )
                            },
                            expression:
                              "customFormItemData.custom_field_data_layout.xl",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { newBtn: "" },
              on: { new: _vm.toSave, cancel: _vm.closeDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }